import type Highcharts from 'highcharts'
import {sanitize} from '@github-ui/sanitize'
import type {DonutChartProps, PieChartProps, PieChartSeriesOptions} from '../types'
import Chart from '../Chart'

const emptySeries: PieChartSeriesOptions[] = []

const BasePieChart = ({
  innerSize,
  series = emptySeries,
  colors,
  labels = false,
  tooltipOptions,
  overrideOptionsNotRecommended,
}: PieChartProps & {innerSize?: string}) => {
  const pieSeries: Highcharts.SeriesOptionsType[] = series.map(options => ({
    ...options,
    type: 'pie',
    data: options.data?.map(point => {
      const namedPoint = Array.isArray(point) ? {name: point[0], y: point[1]} : point
      if (
        namedPoint === null ||
        typeof namedPoint !== 'object' ||
        !('name' in namedPoint) ||
        typeof namedPoint.name !== 'string'
      ) {
        return namedPoint
      }

      /* eslint-disable-next-line @github-ui/github-monorepo/no-custom-sanitize-config --
         Highcharts interpolates point.key into its HTML tooltip; pie point names are plain text. */
      return {...namedPoint, name: sanitize(namedPoint.name, {ALLOWED_TAGS: [], RETURN_TRUSTED_TYPE: false})}
    }),
  }))

  return (
    <Chart
      type="pie"
      series={pieSeries}
      colors={colors}
      tooltipOptions={tooltipOptions}
      plotOptions={{
        pie: {
          innerSize,
          showInLegend: true,
          dataLabels: {
            enabled: labels,
            format: '{point.name}: {point.percentage:.1f}%',
          },
        },
      }}
      overrideOptionsNotRecommended={{
        ...overrideOptionsNotRecommended,
        legend: {
          enabled: true,
          ...overrideOptionsNotRecommended?.legend,
        },
      }}
    />
  )
}

const PieChart = (props: PieChartProps) => {
  return <BasePieChart {...props} innerSize={undefined} />
}

export const DonutChart = (props: DonutChartProps) => {
  return <BasePieChart {...props} innerSize="60%" />
}

export default PieChart
